var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"m12.288 7.2542v9.5873h-0.576v-9.683h0.576z","stroke-width":"0"}}),_c('path',{attrs:{"d":"m16.746 12.288h-9.5873v-0.576h9.683v0.576z","stroke-width":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }